import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

const incomeSettingRouter = {
    UPDATE_ANTIPASSBACK: "/dashboard/income/setting/set-antipassback",
    GET_INCOME: "dashboard/income/setting/findByCompany",
};

export default {
    updateAntipassback(companyId) {
        let newInfo ={};
        return new Promise(resolve => {
            http.put(incomeSettingRouter.UPDATE_ANTIPASSBACK, {params: {companyId}})
                .then(({data}) => {
                    newInfo = data;
                   if(newInfo.message==null){
                    newInfo.message="Error al aplicar amnistía a mensualidad";
                   }
                })
                .catch(ex => {
                    newInfo.message=ex.message;
                })
                .finally(() => {
                    resolve(newInfo)});
        });
    },

    findIncomeSetting(companyId){
        return new Promise(resolve => {
            let newData = {};
            http.get(incomeSettingRouter.GET_INCOME, {
                params:{companyId: companyId}
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    }
}